import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface ErrorMessageContactProps {
  supportPhone: string;
  supportEmail: string;
}

export const ErrorMessageContact = ({ supportPhone, supportEmail }: ErrorMessageContactProps) => {
  const { palette } = useCustomTheme();

  return (
    <Font variant="body2">
      <Box display={'flex'} gridGap={'8px'} flexDirection={'column'}>
        <Text tId={'ERROR_BOUNDARY_TEXT_CONTACT'} />
        <Box display={'flex'} gridGap={'8px'} flexDirection={'row'}>
          <Icon size={20} color={palette.grey[400]}>
            {'email'}
          </Icon>
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </Box>
        <Box display={'flex'} gridGap={'8px'} flexDirection={'row'}>
          <Icon size={20} color={palette.grey[400]}>
            {'phone'}
          </Icon>
          <a href={`tel:${supportPhone.replace(/ /g, '')}`}>{supportPhone}</a>
        </Box>
      </Box>
    </Font>
  );
};
